import { supabase } from "./supabase"

export async function uploadImage(file: File, path: string): Promise<string> {
  const fileExtension = file.name.split(".").pop()
  const fileName = `${Date.now()}-${Math.random().toString(36).substring(7)}.${fileExtension}`
  const fullPath = `${path}/${fileName}`

  const { data, error } = await supabase.storage.from("images").upload(fullPath, file, {
    cacheControl: "3600",
    upsert: false,
  })

  if (error) throw error

  // Get public URL
  const {
    data: { publicUrl },
  } = supabase.storage.from("images").getPublicUrl(data.path)

  return publicUrl
}

export async function uploadAvatar(file: File, userId: string): Promise<string> {
  return uploadImage(file, `avatars/${userId}`)
}

export async function uploadCoverImage(file: File, userId: string): Promise<string> {
  return uploadImage(file, `covers/${userId}`)
}

export async function uploadPostImage(file: File, userId: string, postId: string): Promise<string> {
  return uploadImage(file, `posts/${userId}/${postId}`)
}

export async function deleteImage(url: string): Promise<void> {
  try {
    // Extract path from URL
    const urlObj = new URL(url)
    const path = urlObj.pathname.split("/storage/v1/object/public/images/")[1]

    if (!path) {
      console.error("Invalid image URL:", url)
      return
    }

    const { error } = await supabase.storage.from("images").remove([path])

    if (error) {
      console.error("Error deleting image:", error)
    }
  } catch (error) {
    console.error("Error deleting image:", error)
  }
}

export function validateImageFile(file: File): { valid: boolean; error?: string } {
  const allowedTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"]
  const maxSize = 5 * 1024 * 1024 // 5MB

  if (!allowedTypes.includes(file.type)) {
    return { valid: false, error: "File must be an image (JPEG, PNG, GIF, or WebP)" }
  }

  if (file.size > maxSize) {
    return { valid: false, error: "File size must be less than 5MB" }
  }

  return { valid: true }
}
